import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "HondaPPS",
    component: () => import("../views/DragAndDrop"),
    meta: { isAuthenticated: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAuthenticated) {
    const basePath = window.location.toString();
    if (!Vue.$keycloak.authenticated) {
      Vue.$keycloak.login({ redirectUri: basePath });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
